<div
  class="min-h-screen bg-[#F3F4F6] text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300"
>
  <!-- Header -->
  <div
    class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4"
  >
    <div>
      <h1
        class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight"
      >
        จัดการข้อมูลบัตรจอดรถ
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        จัดการข้อมูลและดูประวัติบัตรจอดรถล่วงหน้า
      </p>
      <div *ngIf="isAccessScoped"
        class="mt-3 rounded-xl border border-sky-200 bg-sky-50/80 dark:bg-sky-950/30 dark:border-sky-800 px-3 py-2 text-sm text-sky-900 dark:text-sky-100">
        <span class="font-bold">ขอบเขตกลุ่ม:</span> {{ accessScopeLabel }}
        <span class="text-sky-700/80 dark:text-sky-300/80">
          — แสดงเฉพาะบัตรในกลุ่มสิทธิ์
          · {{ accessScope?.clientIds?.length ? ('บริษัทผู้เช่า ' + accessScope?.clientIds?.length + ' บริษัท') : 'ทุกบริษัทผู้เช่าในลาน' }}
          · Subscription {{ accessScope?.subscriptionIds?.length || 0 }} รายการ
          <ng-container *ngIf="accessScope?.canManageFreeCards"> · จัดการบัตรได้</ng-container>
          <ng-container *ngIf="!accessScope?.canManageFreeCards"> · ดูอย่างเดียว</ng-container>
          <ng-container *ngIf="accessScope?.canDeleteCardReturnQuota"> · ลบคืนโควต้าได้</ng-container>
        </span>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <button
        (click)="toggleDashboard()"
        class="hidden sm:flex px-4 py-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 items-center gap-2"
        [title]="showDashboard ? 'ซ่อน Dashboard' : 'แสดง Dashboard'"
      >
        <span class="material-icons">{{
          showDashboard ? "visibility_off" : "visibility"
        }}</span>
        <span class="text-sm font-bold">{{
          showDashboard ? "ซ่อน Dashboard" : "แสดง Dashboard"
        }}</span>
      </button>
      <button
        (click)="onRefresh()"
        class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center"
        title="รีเฟรชข้อมูล"
      >
        <span class="material-icons">refresh</span>
      </button>
      <button
        *ngIf="canCreate"
        type="button"
        (click)="downloadSampleExcel()"
        class="w-full sm:w-auto px-4 py-3 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-bold rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 hover:border-amber-300 transition-all flex items-center justify-center gap-2"
        title="ดาวน์โหลดไฟล์ Excel ตัวอย่าง"
      >
        <span class="material-icons text-xl">download</span>
        Excel ตัวอย่าง
      </button>
      <button
        *ngIf="canCreate"
        type="button"
        (click)="openImportModal()"
        class="w-full sm:w-auto px-4 py-3 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-bold rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 hover:border-amber-300 transition-all flex items-center justify-center gap-2"
      >
        <span class="material-icons text-xl">upload_file</span>
        Import Excel
      </button>
      <button
        *ngIf="canCreate"
        (click)="navigateToCreate()"
        class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-[0_4px_15px_rgb(251,191,36,0.3)] hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2"
      >
        <span class="material-icons text-xl">add_circle</span>
        เพิ่มบัตรจอดรถ
      </button>
    </div>
  </div>

  <!-- Collapsible Dashboard Section -->
  <div
    class="overflow-hidden transition-all duration-500 ease-in-out"
    [style.max-height]="showDashboard ? '3000px' : '0'"
    [style.opacity]="showDashboard ? '1' : '0'"
    [style.margin-bottom]="showDashboard ? '2rem' : '0'"
  >
    <!-- Stats Cards -->
    <div
      *ngIf="dashboardStats.length > 0"
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
    >
      <div
        *ngFor="let stat of dashboardStats; let i = index"
        class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
        [ngStyle]="{ 'animation-delay': i * 0.05 + 's' }"
      >
        <div
          class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-[0.15] transition-transform group-hover:scale-110"
          [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"
        ></div>

        <div class="relative z-10 flex justify-between items-start mb-4">
          <div
            class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
            [ngClass]="
              stat.color
                .replace('text-', 'bg-')
                .replace('600', '50')
                .replace('500', '50') +
              ' ' +
              stat.color +
              ' dark:bg-opacity-20'
            "
          >
            <span class="material-icons text-2xl">{{ stat.icon }}</span>
          </div>
        </div>

        <div class="relative z-10">
          <h4
            class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1 truncate"
          >
            {{ stat.title }}
          </h4>
          <div
            class="text-3xl font-black text-slate-800 dark:text-slate-100 tracking-tight"
          >
            {{ stat.value }}
          </div>
        </div>
      </div>
    </div>

    <!-- Status Ratio Chart -->
    <div
      class="animate-fade-in bg-white dark:bg-slate-800 rounded-4xl shadow-lg shadow-gray-100/50 dark:shadow-slate-700 border border-gray-100/50 dark:border-slate-700 p-8 mb-8 transition-all duration-300"
      style="animation-delay: 0.24s"
    >
      <div
        class="flex justify-between items-center"
        [class.mb-6]="showRatioChart"
      >
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100">
          สัดส่วนสถานะบัตร
        </h3>
        <button
          (click)="showRatioChart = !showRatioChart"
          class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 hover:text-amber-500 transition-colors"
        >
          <span class="material-icons">{{
            showRatioChart ? "expand_less" : "expand_more"
          }}</span>
        </button>
      </div>

      <div
        *ngIf="showRatioChart"
        class="animate-fade-in flex flex-col lg:flex-row items-center justify-center gap-10 mt-2"
      >
        <div class="relative w-36 h-36 flex-shrink-0">
          <svg viewBox="0 0 36 36" class="w-full h-full transform -rotate-90">
            <path
              class="text-slate-100 dark:text-slate-700"
              stroke-dasharray="100, 100"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="currentColor"
              stroke-width="3.5"
              stroke-linecap="round"
            />
            <path
              class="text-emerald-500 transition-all duration-1000 ease-out"
              [attr.stroke-dasharray]="activePercent + ', 100'"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="currentColor"
              stroke-width="3.5"
              stroke-linecap="round"
            />
          </svg>
          <div
            class="absolute inset-0 flex flex-col items-center justify-center"
          >
            <span
              class="text-3xl font-black text-slate-800 dark:text-slate-100 leading-none"
              >{{ activePercent }}%</span
            >
            <span
              class="text-[10px] font-bold text-emerald-500 uppercase tracking-widest mt-1"
              >Active</span
            >
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 w-full max-w-2xl">
          <div class="flex items-center gap-3">
            <div
              class="w-4 h-4 rounded-full bg-emerald-500 shadow-sm shadow-emerald-500/40"
            ></div>
            <div class="flex flex-col">
              <span
                class="text-[10px] font-bold text-slate-400 uppercase tracking-wider"
                >ใช้งานอยู่</span
              >
              <span
                class="text-lg font-black text-slate-700 dark:text-slate-200 leading-tight"
                >{{ activePercent }}%</span
              >
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div
              class="w-4 h-4 rounded-full bg-amber-500 shadow-sm shadow-amber-500/40"
            ></div>
            <div class="flex flex-col">
              <span
                class="text-[10px] font-bold text-slate-400 uppercase tracking-wider"
                >หมดอายุ</span
              >
              <span
                class="text-lg font-black text-slate-700 dark:text-slate-200 leading-tight"
                >{{ expiredPercent }}%</span
              >
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div
              class="w-4 h-4 rounded-full bg-rose-500 shadow-sm shadow-rose-500/40"
            ></div>
            <div class="flex flex-col">
              <span
                class="text-[10px] font-bold text-slate-400 uppercase tracking-wider"
                >ยกเลิก</span
              >
              <span
                class="text-lg font-black text-slate-700 dark:text-slate-200 leading-tight"
                >{{ cancelledPercent }}%</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
      <!-- Trend Chart -->
      <div
        class="animate-fade-in lg:col-span-2 bg-white dark:bg-slate-800 rounded-4xl shadow-lg shadow-gray-100/50 dark:shadow-slate-700 border border-gray-100/50 dark:border-slate-700 pt-8 pb-12 px-8 md:px-12 relative overflow-visible z-0"
        style="animation-delay: 0.25s"
      >
        <div
          class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4"
        >
          <div>
            <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100">
              แนวโน้มการออกบัตร
              <span
                class="text-sm font-medium text-slate-500 dark:text-slate-300 ml-2 bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded-full"
              >
                {{ chartTotalCount }} รายการ
              </span>
            </h3>
            <div class="flex items-center gap-4 text-xs font-medium mt-1">
              <span class="flex items-center gap-1">
                <span class="w-2 h-2 rounded-full bg-amber-400"></span>
                <span class="text-slate-600 dark:text-slate-300">{{
                  chartMode === "daily" ? "รายวัน" : "รายเดือน"
                }}</span>
                <span class="text-slate-400 dark:text-slate-500">
                  <ng-container
                    *ngIf="chartMode === 'daily' && dailySubMode === 'default'"
                    >( 7 วันย้อนหลัง )</ng-container
                  >
                  <ng-container
                    *ngIf="chartMode === 'daily' && dailySubMode === 'custom'"
                    >( สูงสุด 10 วัน )</ng-container
                  >
                  <ng-container *ngIf="chartMode === 'monthly'"
                    >( {{ selectedMonthStart | date: "MM/yyyy" }} -
                    {{ selectedMonthEnd | date: "MM/yyyy" }} )</ng-container
                  >
                </span>
              </span>
            </div>
          </div>

          <div class="flex flex-col items-end gap-2">
            <div class="flex items-center gap-2 min-h-[34px]">
              <div
                *ngIf="chartMode === 'daily'"
                class="flex items-center gap-2"
              >
                <div
                  class="flex bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 gap-1"
                >
                  <button
                    (click)="setDailySubMode('default')"
                    class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                    [ngClass]="
                      dailySubMode === 'default'
                        ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm'
                        : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'
                    "
                  >
                    ทั้งหมด
                  </button>
                  <button
                    (click)="setDailySubMode('custom')"
                    class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                    [ngClass]="
                      dailySubMode === 'custom'
                        ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm'
                        : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'
                    "
                  >
                    กำหนดเอง
                  </button>
                </div>

                <div
                  *ngIf="dailySubMode === 'custom'"
                  class="flex items-center bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1"
                >
                  <input
                    type="date"
                    [(ngModel)]="customStartDate"
                    (change)="onCustomDateChange()"
                    [max]="customEndDate"
                    class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-[105px] dark:[color-scheme:dark]"
                  />
                  <span class="mx-1 text-slate-300 dark:text-slate-600">-</span>
                  <input
                    type="date"
                    [(ngModel)]="customEndDate"
                    (change)="onCustomDateChange()"
                    [min]="customStartDate"
                    [max]="maxCustomDate"
                    class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-[105px] dark:[color-scheme:dark]"
                  />
                  <button
                    (click)="resetCustomDate()"
                    class="ml-2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-colors cursor-pointer"
                    title="รีเซ็ต"
                  >
                    <span class="material-icons text-[16px]">refresh</span>
                  </button>
                </div>
              </div>

              <div
                *ngIf="chartMode === 'monthly'"
                class="flex items-center gap-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1"
              >
                <input
                  type="month"
                  [(ngModel)]="selectedMonthStart"
                  (change)="onChartMonthChange()"
                  class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px] dark:[color-scheme:dark]"
                />
                <span class="text-slate-300 dark:text-slate-600 mx-1">-</span>
                <input
                  type="month"
                  [(ngModel)]="selectedMonthEnd"
                  (change)="onChartMonthChange()"
                  [min]="selectedMonthStart"
                  [max]="maxMonthEnd"
                  class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px] dark:[color-scheme:dark]"
                />
              </div>
            </div>

            <div class="flex items-center gap-2">
              <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-lg">
                <button
                  (click)="setChartType('line')"
                  [class]="
                    chartType === 'line'
                      ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm'
                      : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  "
                  class="p-1 px-2 rounded-md transition-all"
                >
                  <span class="material-icons text-sm">show_chart</span>
                </button>
                <button
                  (click)="setChartType('bar')"
                  [class]="
                    chartType === 'bar'
                      ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm'
                      : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  "
                  class="p-1 px-2 rounded-md transition-all"
                >
                  <span class="material-icons text-sm">bar_chart</span>
                </button>
              </div>

              <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-lg">
                <button
                  (click)="setChartMode('daily')"
                  [class]="
                    chartMode === 'daily'
                      ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm'
                      : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  "
                  class="px-3 py-1 text-xs font-bold rounded-md transition-all"
                >
                  รายวัน
                </button>
                <button
                  (click)="setChartMode('monthly')"
                  [class]="
                    chartMode === 'monthly'
                      ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm'
                      : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  "
                  class="px-3 py-1 text-xs font-bold rounded-md transition-all"
                >
                  รายเดือน
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="relative h-64 w-full pl-6 overflow-x-auto">
          <div
            class="absolute inset-y-0 left-[-30px] bottom-0 w-8 flex flex-col justify-between text-[9px] text-slate-400 font-medium pointer-events-none py-2 items-end pr-1"
          >
            <span>{{ yAxisLabels[4] }}</span>
            <span>{{ yAxisLabels[3] }}</span>
            <span>{{ yAxisLabels[2] }}</span>
            <span>{{ yAxisLabels[1] }}</span>
            <span class="translate-y-1">{{ yAxisLabels[0] }}</span>
          </div>

          <div [style.width]="chartWidth" class="h-full min-w-full relative">
            <svg
              viewBox="0 0 100 100"
              class="w-full h-full overflow-visible"
              preserveAspectRatio="none"
            >
              <defs>
                <linearGradient
                  id="parkingCardGradientArea"
                  x1="0"
                  x2="0"
                  y1="0"
                  y2="1"
                >
                  <stop offset="0%" stop-color="#fbbf24" stop-opacity="0.4" />
                  <stop offset="100%" stop-color="#fbbf24" stop-opacity="0" />
                </linearGradient>
              </defs>

              <g class="text-slate-200 dark:text-slate-700 pointer-events-none">
                <line
                  x1="0"
                  y1="100"
                  x2="100"
                  y2="100"
                  stroke="currentColor"
                  stroke-width="0.5"
                />
                <line
                  x1="0"
                  y1="75"
                  x2="100"
                  y2="75"
                  stroke="currentColor"
                  stroke-width="0.5"
                  stroke-dasharray="2"
                />
                <line
                  x1="0"
                  y1="50"
                  x2="100"
                  y2="50"
                  stroke="currentColor"
                  stroke-width="0.5"
                  stroke-dasharray="2"
                />
                <line
                  x1="0"
                  y1="25"
                  x2="100"
                  y2="25"
                  stroke="currentColor"
                  stroke-width="0.5"
                  stroke-dasharray="2"
                />
                <line
                  x1="0"
                  y1="0"
                  x2="100"
                  y2="0"
                  stroke="currentColor"
                  stroke-width="0.5"
                  stroke-dasharray="2"
                />
              </g>

              <g *ngIf="chartType === 'line'">
                <polygon
                  [attr.points]="currentMonthAreaPoints"
                  fill="url(#parkingCardGradientArea)"
                  class="opacity-50 transition-all duration-500"
                />
                <polyline
                  [attr.points]="currentMonthPoints"
                  fill="none"
                  stroke="#fbbf24"
                  stroke-width="0.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="drop-shadow-sm transition-all duration-500"
                />
                <circle
                  *ngFor="let point of currentMonthDots"
                  [attr.cx]="point.x"
                  [attr.cy]="point.y"
                  r="1.5"
                  fill="#fff"
                  stroke="#fbbf24"
                  stroke-width="1"
                  class="opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                >
                  <title>{{ point.label }}: {{ point.value }}</title>
                </circle>
              </g>

              <g *ngIf="chartType === 'bar'">
                <rect
                  *ngFor="let point of currentMonthDots"
                  [attr.x]="point.x - 2"
                  [attr.y]="point.y"
                  width="4"
                  [attr.height]="100 - point.y"
                  [attr.fill]="point.color"
                  class="hover:opacity-80 hover:fill-yellow-500 border-2 border-white dark:border-slate-800 transition-all duration-300 cursor-pointer rx-[1px]"
                >
                  <title>{{ point.label }}: {{ point.value }}</title>
                </rect>
              </g>
            </svg>

            <div
              class="absolute bottom-0 left-0 right-0 translate-y-8 h-8 pointer-events-none"
            >
              <ng-container *ngFor="let dot of currentMonthDots; let i = index">
                <div
                  *ngIf="
                    currentMonthDots.length <= 15 ||
                    i % 5 === 0 ||
                    i === 0 ||
                    i === currentMonthDots.length - 1
                  "
                  class="absolute top-0 flex flex-col items-center whitespace-nowrap"
                  [style.left.%]="dot.x"
                  style="transform: translateX(-50%)"
                >
                  <span class="text-[10px] text-slate-400 font-medium">{{
                    dot.label
                  }}</span>
                  <span
                    *ngIf="dot.subLabel"
                    class="text-[9px] text-slate-400"
                    >{{ dot.subLabel }}</span
                  >
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Recent Activity -->
      <div
        class="animate-fade-in bg-white dark:bg-slate-800 rounded-4xl shadow-lg shadow-gray-100/50 dark:shadow-slate-700 border border-gray-100/50 dark:border-slate-700 p-8"
        style="animation-delay: 0.3s"
      >
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 mb-6">
          บัตรใหม่ล่าสุด
        </h3>
        <div class="relative">
          <div
            class="absolute left-5 top-4 bottom-4 w-0.5 bg-slate-100 dark:bg-slate-700"
          ></div>
          <div class="space-y-6 relative">
            <div
              *ngFor="let item of recentActivity"
              class="flex items-start gap-4 group"
            >
              <div
                class="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-amber-600 dark:text-amber-400 text-sm font-bold shadow-sm ring-4 ring-white dark:ring-slate-800 z-10 bg-amber-100 dark:bg-amber-500/20 transition-transform group-hover:scale-110"
              >
                {{ item.initial }}
              </div>
              <div class="flex-1 pt-1">
                <div class="flex justify-between items-start">
                  <h5
                    class="text-sm font-bold text-slate-800 dark:text-slate-200 group-hover:text-amber-500 transition-colors"
                  >
                    {{ item.name }}
                  </h5>
                  <span
                    class="text-[10px] font-semibold text-slate-400 dark:text-slate-400 bg-slate-50 dark:bg-slate-700 px-2 py-0.5 rounded-full border border-slate-100 dark:border-slate-600 whitespace-nowrap"
                  >
                    {{ item.timeAgo }}</span
                  >
                </div>
                <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                  {{ item.info }}
                </p>
              </div>
            </div>
            <div
              *ngIf="recentActivity.length === 0 && !isDashboardLoading"
              class="text-center text-slate-400 dark:text-slate-500 py-10"
            >
              <span class="material-icons text-3xl mb-2 opacity-50"
                >history</span
              >
              <p class="text-sm">ไม่มีกิจกรรมล่าสุด</p>
            </div>
            <div
              *ngIf="isDashboardLoading"
              class="text-center text-slate-400 dark:text-slate-500 py-10"
            >
              <span class="material-icons text-3xl mb-2 opacity-50 animate-spin"
                >sync</span
              >
              <p class="text-sm">กำลังโหลด...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
    style="animation-delay: 0.2s"
  >
    <div
      class="p-4 sm:p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col gap-4"
    >
      <h3
        class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2 shrink-0 whitespace-nowrap"
      >
        <span class="material-icons text-amber-500 shrink-0">list_alt</span>
        รายการบัตรจอดรถ
      </h3>

      <div class="flex flex-col gap-3 w-full min-w-0">
        <!-- Row: client + vehicle type -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full min-w-0">
          <!-- Client filter (searchable) -->
          <div class="relative w-full min-w-0 z-40">
            <label class="block text-xs font-bold text-slate-500 mb-1"
              >กรองลูกค้า</label
            >
            <p class="hidden sm:block text-[11px] text-slate-400 mb-1.5">
              สามารถพิมพ์ค้นหาชื่อลูกค้าได้ในช่องนี้
            </p>
            <div
              class="relative flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]"
            >
              <span
                class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none"
                >person_search</span
              >
              <input
                type="text"
                [(ngModel)]="clientSearchText"
                (focus)="openClientDropdown()"
                (input)="onClientSearchInput()"
                (blur)="closeClientDropdown()"
                placeholder="ค้นหาหรือเลือกลูกค้า..."
                class="w-full min-w-0 pl-10 pr-9 py-2 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:outline-none placeholder:text-slate-400"
              />
              <button
                *ngIf="selectedClientId"
                type="button"
                (mousedown)="$event.preventDefault(); clearClientFilter()"
                class="absolute right-2 text-slate-400 hover:text-rose-500"
              >
                <span class="material-icons text-lg">close</span>
              </button>
            </div>
            <button
              *ngIf="isClientDropdownOpen"
              type="button"
              class="fixed inset-0 z-30 cursor-default"
              (click)="closeClientDropdown()"
            ></button>
            <div
              *ngIf="isClientDropdownOpen"
              class="absolute top-full mt-2 left-0 right-0 max-h-56 overflow-y-auto bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50"
            >
              <button
                *ngFor="let c of clientFilterOptions"
                type="button"
                (mousedown)="$event.preventDefault(); selectClient(c)"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors"
              >
                {{ c.name }}
              </button>
              <div
                *ngIf="clientFilterOptions.length === 0"
                class="px-4 py-3 text-sm text-slate-400"
              >
                ไม่พบลูกค้า
              </div>
              <div
                *ngIf="!clientSearchText.trim() && clients.length > 20"
                class="px-4 py-2 text-xs text-slate-400 border-t border-slate-100 dark:border-slate-700"
              >
                แสดง 20 รายการแรก — พิมพ์เพื่อค้นหาเพิ่ม
              </div>
            </div>
          </div>

          <!-- Vehicle type filter (searchable) -->
          <div class="relative w-full min-w-0 z-40">
            <label class="block text-xs font-bold text-slate-500 mb-1"
              >กรองประเภทรถ</label
            >
            <p class="hidden sm:block text-[11px] text-slate-400 mb-1.5">
              สามารถพิมพ์ค้นหาประเภทรถได้ในช่องนี้
            </p>
            <div
              class="relative flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]"
            >
              <span
                class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none"
                >directions_car</span
              >
              <input
                type="text"
                [(ngModel)]="vehicleTypeSearchText"
                (focus)="openVehicleTypeDropdown()"
                (input)="onVehicleTypeSearchInput()"
                (blur)="closeVehicleTypeDropdown()"
                placeholder="ค้นหาหรือเลือกประเภทรถ..."
                class="w-full min-w-0 pl-10 pr-9 py-2 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:outline-none placeholder:text-slate-400"
              />
              <button
                *ngIf="selectedVehicleTypeId"
                type="button"
                (mousedown)="$event.preventDefault(); clearVehicleTypeFilter()"
                class="absolute right-2 text-slate-400 hover:text-rose-500"
              >
                <span class="material-icons text-lg">close</span>
              </button>
            </div>
            <button
              *ngIf="isVehicleTypeDropdownOpen"
              type="button"
              class="fixed inset-0 z-30 cursor-default"
              (click)="closeVehicleTypeDropdown()"
            ></button>
            <div
              *ngIf="isVehicleTypeDropdownOpen"
              class="absolute top-full mt-2 left-0 right-0 max-h-56 overflow-y-auto bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 custom-scrollbar"
            >
              <button
                *ngFor="let v of vehicleTypeFilterOptions"
                type="button"
                (mousedown)="$event.preventDefault(); selectVehicleType(v)"
                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors"
              >
                {{ v.typeName }}
              </button>
              <div
                *ngIf="vehicleTypeFilterOptions.length === 0"
                class="px-4 py-3 text-sm text-slate-400"
              >
                ไม่พบประเภทรถ
              </div>
              <div
                *ngIf="!vehicleTypeSearchText.trim() && vehicleTypes.length > 20"
                class="px-4 py-2 text-xs text-slate-400 border-t border-slate-100 dark:border-slate-700"
              >
                แสดง 20 รายการแรก — พิมพ์เพื่อค้นหาเพิ่ม
              </div>
            </div>
          </div>
        </div>

        <!-- Row: status + search -->
        <div
          class="flex flex-col lg:flex-row gap-3 w-full min-w-0 lg:items-center"
        >
          <!-- Status Filter Group -->
          <div
            class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm overflow-x-auto w-full lg:w-auto lg:max-w-full shrink-0 custom-scrollbar"
          >
            <button
              type="button"
              (click)="selectStatus(1)"
              [class]="
                filterStatus === 1
                  ? 'bg-white dark:bg-slate-700 text-green-600 dark:text-green-400 shadow-sm'
                  : 'text-slate-400 dark:text-slate-500 hover:text-green-600 dark:hover:text-green-400'
              "
              class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200 ease-in-out whitespace-nowrap shrink-0"
            >
              ใช้งานอยู่
            </button>
            <div
              class="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-1 shrink-0"
            ></div>
            <button
              type="button"
              (click)="selectStatus(2)"
              [class]="
                filterStatus === 2
                  ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
                  : 'text-slate-400 dark:text-slate-500 hover:text-amber-600 dark:hover:text-amber-400'
              "
              class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200 ease-in-out whitespace-nowrap shrink-0"
            >
              หมดอายุ
            </button>
          </div>

          <div
            class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-visible w-full min-w-0 flex-1 relative z-30 h-[46px]"
          >
            <!-- Search Type Dropdown -->
            <div
              class="relative w-[110px] sm:min-w-[130px] sm:w-auto shrink-0 border-r border-slate-200 dark:border-slate-700 h-full"
            >
              <button
                type="button"
                (click)="toggleSearchTypeDropdown()"
                class="w-full h-full pl-3 sm:pl-4 pr-2 sm:pr-3 text-sm font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between gap-1 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-l-xl transition-all focus:outline-none"
              >
                <span class="truncate">{{ currentSearchTypeLabel }}</span>
                <span
                  class="material-icons text-sm text-slate-400 dark:text-slate-500 transition-transform duration-200 shrink-0"
                  [ngClass]="{ 'rotate-180': isSearchTypeDropdownOpen }"
                  >expand_more</span
                >
              </button>

              <button
                *ngIf="isSearchTypeDropdownOpen"
                type="button"
                class="fixed inset-0 cursor-default z-50"
                (click)="toggleSearchTypeDropdown()"
              ></button>

              <div
                *ngIf="isSearchTypeDropdownOpen"
                class="absolute top-full mt-2 left-0 w-[180px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden animate-fade-in-up"
              >
                <button
                  type="button"
                  (click)="selectSearchType('license')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span
                    class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >directions_car</span
                  >
                  ทะเบียนรถ
                </button>
                <button
                  type="button"
                  (click)="selectSearchType('name')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span
                    class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >label</span
                  >
                  ชื่อลูกค้า
                </button>
                <button
                  type="button"
                  (click)="selectSearchType('card_name')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span
                    class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >badge</span
                  >
                  หมายเลขบัตร
                </button>
                <button
                  type="button"
                  (click)="selectSearchType('card_code')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span
                    class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >pin</span
                  >
                  รหัสระบบ
                </button>
                <button
                  type="button"
                  (click)="selectSearchType('uid')"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2"
                >
                  <span
                    class="material-icons text-lg text-slate-400 dark:text-slate-500"
                    >vpn_key</span
                  >
                  UID
                </button>
              </div>
            </div>

            <!-- Search Input -->
            <div class="relative flex-1 flex w-full min-w-0 h-full">
              <span
                class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 dark:text-slate-500 text-xl pointer-events-none"
                >search</span
              >
              <input
                type="text"
                placeholder="ค้นหา..."
                [(ngModel)]="searchText"
                (keyup.enter)="onSearch()"
                class="w-full flex-1 min-w-0 pl-10 pr-2 h-full bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600"
              />
              <button
                type="button"
                (click)="onSearch()"
                class="px-3 sm:px-5 text-sm font-bold text-white bg-amber-400 hover:bg-amber-500 rounded-r-xl shadow-sm transition-colors whitespace-nowrap shrink-0"
              >
                ค้นหา
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto h-[950px] relative custom-scrollbar">
      <!-- Loading overlay inside table area -->
      <!-- <div *ngIf="isLoading"
                class="absolute inset-0 z-20 bg-white/40 dark:bg-slate-900/40 backdrop-blur-[2px] flex items-center justify-center pointer-events-none transition-all duration-300">
                <div
                    class="flex flex-col items-center gap-3 bg-white/80 dark:bg-slate-800/80 p-4 rounded-2xl shadow-lg backdrop-blur-md">
                    <div
                        class="w-8 h-8 border-4 border-slate-200 dark:border-slate-700 border-t-amber-500 rounded-full animate-spin">
                    </div>
                    <span
                        class="text-sm font-bold text-slate-600 dark:text-slate-300 animate-pulse">กำลังโหลดข้อมูล...</span>
                </div>
            </div> -->
      <app-pss-loading *ngIf="isLoading"></app-pss-loading>

      <table
        class="w-full text-left border-collapse"
        [class.opacity-50]="isLoading"
        [class.pointer-events-none]="isLoading"
      >
        <thead
          class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm"
        >
          <tr>
            <th
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center w-14 whitespace-nowrap"
            >
              #
            </th>
            <th
              (click)="sortData('cardName')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                หมายเลขบัตร
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'cardName'"
                  >{{
                    sortColumn === "cardName" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('name')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                ชื่อลูกค้า / ประเภทสิทธิ์ / บัตรสมาชิก
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'name'"
                  >{{
                    sortColumn === "name" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('clientName')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                บริษัท / ผู้เช่า
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'clientName'"
                  >{{
                    sortColumn === "clientName" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('vehicleTypeName')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                ประเภทรถ
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'vehicleTypeName'"
                  >{{
                    sortColumn === "vehicleTypeName" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('license')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                ทะเบียนรถ
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'license'"
                  >{{
                    sortColumn === "license" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('expireDate')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group whitespace-nowrap"
            >
              <div class="flex items-center gap-1">
                หมดอายุ / ออกเมื่อ
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'issueDate' || sortColumn === 'expireDate'"
                  >{{
                    (sortColumn === "issueDate" || sortColumn === "expireDate") && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}</span
                >
              </div>
            </th>

            <th
              (click)="sortData('status')"
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group text-center whitespace-nowrap"
            >
              <div class="flex items-center justify-center gap-1">
                สถานะ
                <span
                  class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400 transition-all"
                  [class.opacity-100]="sortColumn === 'status'"
                >
                  {{
                    sortColumn === "status" && sortDirection === "asc"
                      ? "arrow_upward"
                      : "arrow_downward"
                  }}
                </span>
              </div>
            </th>

            <th
              class="p-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center"
            >
              จัดการ
            </th>
          </tr>
        </thead>

        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr
            *ngFor="
              let c of filteredAndPaginatedData;
              let i = index;
              trackBy: trackByCardId
            "
            (click)="openCardModal(c)"
            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200 cursor-pointer"
            [ngStyle]="{ 'animation-delay': i * 0.03 + 's' }"
          >
            <td
              class="p-4 text-center text-sm font-bold text-slate-400 dark:text-slate-500 whitespace-nowrap"
            >
              {{ getRowNumber(i) }}
            </td>

            <td class="p-4 whitespace-nowrap">
              <div class="flex flex-col gap-0.5 min-w-0">
                <span
                  class="text-xs text-slate-500 dark:text-slate-400 truncate"
                  >{{ c.cardName || "—" }}</span
                >
                <span
                  class="text-[11px] font-mono text-slate-400 dark:text-slate-500 truncate max-w-[14rem]"
                  [title]="c.cardCode || ''"
                  >{{ c.cardCode || "—" }}</span
                >
              </div>
            </td>

            <td class="p-4 whitespace-nowrap">
              <div class="flex flex-col gap-0.5">
                <span
                  class="text-sm font-bold text-slate-700 dark:text-slate-200"
                  >{{ c.name || "-" }}</span
                >
                <span class="text-xs text-slate-400 dark:text-slate-500">{{
                  c.cardTypeName || "-"
                }}</span>
                <span
                  class="inline-flex w-fit mt-0.5 px-2 py-0.5 rounded-md text-[10px] font-bold bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 border border-amber-200/60 dark:border-amber-800/50"
                  [title]="'ประเภทบัตรสมาชิก'"
                  >{{ c.subscriptionName || "—" }}</span
                >
              </div>
            </td>

            <td class="p-4 max-w-[10rem]">
              <span
                class="block text-sm font-medium text-slate-700 dark:text-slate-200 truncate"
                [title]="c.clientName || ''"
              >
                {{ c.clientName || "—" }}
              </span>
            </td>

            <td class="p-4 whitespace-nowrap">
              <span
                class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300"
              >
                {{ c.vehicleTypeName || "—" }}
              </span>
            </td>

            <td class="p-4 whitespace-nowrap">
              <div class="flex items-center gap-1.5">
                <span
                  class="material-icons text-[16px]"
                  [ngClass]="
                    hasPlate(c) ? 'text-emerald-500' : 'text-slate-300'
                  "
                  [title]="c.vehicleTypeName || 'รถยนต์'"
                  >{{ getVehicleIcon(c.vehicleTypeName) }}</span
                >
                <span
                  class="text-sm font-bold font-mono"
                  [ngClass]="
                    hasPlate(c)
                      ? 'text-slate-700 dark:text-slate-200'
                      : 'text-slate-400'
                  "
                >
                  {{ getPlateDisplay(c) }}
                </span>
              </div>
            </td>

            <td class="p-4 whitespace-nowrap">
              <div class="flex flex-col gap-0.5">
                <span class="text-sm font-medium text-slate-700 dark:text-slate-200">
                  <span class="text-[10px] font-bold text-slate-400 uppercase tracking-wide mr-1">หมด</span>
                  {{ c.expireDate | date: "dd/MM/yyyy HH:mm" }}
                </span>
                <span class="text-xs text-slate-400 dark:text-slate-500">
                  <span class="text-[10px] font-bold uppercase tracking-wide mr-1">ออก</span>
                  {{ c.issueDate | date: "dd/MM/yyyy HH:mm" }}
                </span>
              </div>
            </td>

            <td class="p-4 text-center">
              <span
                class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm"
                [ngClass]="{
                  'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800':
                    c.status === 1,
                  'bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800':
                    c.status === 0,
                  'bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400 border-rose-200 dark:border-rose-800':
                    c.status === 2,
                  'bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800':
                    c.status === 3,
                }"
              >
                <span
                  class="w-1.5 h-1.5 rounded-full mr-1.5"
                  [ngClass]="{
                    'bg-green-500': c.status === 1,
                    'bg-amber-500': c.status === 0,
                    'bg-rose-500': c.status === 2,
                    'bg-yellow-500': c.status === 3,
                  }"
                ></span>
                {{ getStatusText(c.status) }}
              </span>
            </td>

            <td class="p-4 text-center whitespace-nowrap relative z-10">
              <div class="flex items-center justify-center gap-2">
                <button
                  *ngIf="canUpdate"
                  (click)="openEditModal(c); $event.stopPropagation()"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 dark:hover:bg-blue-600 hover:text-white transition-all shadow-sm hover:shadow-blue-200 dark:hover:shadow-blue-900/50 hover:scale-110 active:scale-95"
                  title="จัดการข้อมูล"
                >
                  <span class="material-icons text-[18px]">edit</span>
                </button>
                <button
                  *ngIf="canDelete"
                  (click)="openDeleteConfirm(c); $event.stopPropagation()"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-rose-500 dark:text-rose-400 bg-rose-50 dark:bg-rose-900/30 hover:bg-rose-500 dark:hover:bg-rose-600 hover:text-white transition-all shadow-sm hover:shadow-rose-200 dark:hover:shadow-rose-900/50 hover:scale-110 active:scale-95"
                  title="ลบบัตรจอดรถ"
                >
                  <span class="material-icons text-[18px]">delete</span>
                </button>
              </div>
            </td>
          </tr>

          <tr *ngIf="filteredAndPaginatedData.length === 0">
            <td [attr.colspan]="8" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center">
                <div
                  class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3"
                >
                  <span
                    class="material-icons text-3xl text-slate-300 dark:text-slate-600"
                    >search_off</span
                  >
                </div>
                <h3 class="text-slate-800 dark:text-slate-200 font-bold">
                  ไม่พบข้อมูล
                </h3>
                <span class="text-slate-400 dark:text-slate-500 text-sm mt-1"
                  >ลองปรับตัวกรองหรือค้นหาใหม่อีกครั้ง</span
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="p-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4"
    >
      <!-- Pagination Footer -->
      <div
        class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 w-full"
      >
        <div
          class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium"
        >
          <span
            >แสดง {{ startItemIndex | number }} -
            {{ endItemIndex | number }} จาก
            {{ totalItems | number }} รายการ</span
          >
          <select
            (change)="onPageSizeChange($event)"
            [(ngModel)]="pageSize"
            class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-500/30 focus:border-amber-400 dark:focus:border-amber-600 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 transition-colors"
          >
            <option *ngFor="let size of pageSizeOptions" [value]="size">
              {{ size }} / หน้า
            </option>
          </select>
        </div>

        <div class="flex items-center gap-2">
          <button
            (click)="setPage(currentPage - 1)"
            [disabled]="currentPage === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400"
          >
            <span class="material-icons text-sm">chevron_left</span>
          </button>

          <button
            *ngFor="let page of pagesArray"
            (click)="setPage(page)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
            [ngClass]="
              page === currentPage
                ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none'
                : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 dark:hover:text-amber-400'
            "
          >
            {{ page }}
          </button>

          <button
            (click)="setPage(currentPage + 1)"
            [disabled]="currentPage === totalPages || totalPages === 0"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400"
          >
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal สำหรับสร้าง/แก้ไขบัตรจอดรถ -->
<app-modal-parking-card-detail
  *ngIf="isFormModalOpen"
  [mode]="modalMode"
  [cardId]="selectedCardId"
  [siteId]="selectedSiteId"
  [userId]="userId"
  [initialClientId]="selectedClientId"
  (close)="closeFormModal()"
  (saved)="onCardSaved()"
>
</app-modal-parking-card-detail>

<app-modal-parking-card-import
  [isOpen]="isImportModalOpen"
  [siteId]="selectedSiteId"
  [siteName]="siteState.selectedSite()?.name || ''"
  [userId]="userId"
  (onClose)="closeImportModal()"
  (onImported)="onCardsImported()"
>
</app-modal-parking-card-import>

<app-pss-confirm-modal
  *ngIf="isDeleteConfirmOpen"
  title="ยืนยันการลบบัตรจอดรถ?"
  message="ต้องการลบบัตร"
  [highlight]="deleteConfirmHighlight"
  messageSuffix=" — การลบไม่สามารถย้อนกลับได้ (ลาน Taiwan จะลบบนระบบ Taiwan ก่อน)"
  confirmLabel="ใช่ ลบบัตร"
  cancelLabel="ไม่ใช่ ยกเลิก"
  [loading]="isDeleting"
  loadingLabel="กำลังลบ..."
  variant="danger"
  icon="delete_forever"
  [requireRemark]="true"
  remarkLabel="หมายเหตุการลบ (Remark)"
  remarkPlaceholder="ระบุเหตุผลที่ยกเลิก/ลบบัตรนี้"
  [(remark)]="deleteRemark"
  (confirm)="confirmDeleteCard()"
  (cancel)="closeDeleteConfirm()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isDeleting" text="กำลังลบบัตร" detail="โปรดรอสักครู่..."></app-pss-loading>
